import { AppState } from '../state/app.state';
import { createSelector } from '@ngrx/store';

const getSelectedTabNumber = (state: AppState) => state.selectedTabNumber;

export const selectSelectedTabNumber = createSelector(
  getSelectedTabNumber,
  (tabNumber : number) => tabNumber
)